import { EntidadeBase } from 'hay-core-react';
class VoucherModel extends EntidadeBase {
    constructor() {
        super('voucher');
    }
}
const instance = new VoucherModel();
export default instance;
